import "./blocks/sectionblock/script";
import "./blocks/color-box/script";
import "./blocks/course-table/script";
import "./blocks/title-box/script";
import "./blocks/button-block/script";
import "./blocks/schedule-block/script";
import "./blocks/bus-stop/script";
import "./blocks/process-block/script";
import "./blocks/simple-table/script";
import "./blocks/garally-block/script";
import "./blocks/top-slider/script";
import "./blocks/bus-image/script";
import "./blocks/decorated-heading/script";
import "./blocks/image-text-box/script";
import "./blocks/goto-block/script";
import "./blocks/course-benefit/script";
import "./blocks/course-list/script";
import "./blocks/introduce-spot/script";
import "./blocks/introduce-post/script";
import "./blocks/product-list/script";
import "./blocks/faq-block/script";
import "./blocks/goto-popup/script";

const showGotoPopup = () => {
	const body = document.body;

	if(body.classList.contains('close-goto')) return;

	const gotoButton = document.getElementsByClassName('show-goto-popup-btn');

	if(!gotoButton) return;

	const gotoPopUps = document.getElementsByClassName('wp-block-hhb-blocks-goto-popup');

	if (gotoPopUps.length < 1) return;

	const gotoPopUp = gotoPopUps[0];

	[...gotoButton].forEach((elem) => {
		elem.addEventListener('click', function(e) {
			e.preventDefault();

			gotoPopUp.classList.add('open-goto-popup');
			const url = this.href;

			const reservationLink = document.getElementById('js-goto-button');
			reservationLink.href = url;
		})
	})
}
showGotoPopup();

const closeGotoPopup = () => {
	const popUpBg = document.getElementsByClassName('wp-block-hhb-blocks-goto-popup_bg');
	const gotoPopUps = document.getElementsByClassName('wp-block-hhb-blocks-goto-popup');
	if (popUpBg.length < 1 ) return;

	popUpBg[0].addEventListener('click', function(){
		gotoPopUps[0].classList.remove('open-goto-popup');
	})
}
closeGotoPopup();